import React from 'react';
import {Link} from 'react-router-dom';
import {GeoRestaurantMock} from '../../data/geoContent.mock';

type GeoRestaurantListProps = {
    restaurants: GeoRestaurantMock[];
    headingLevel?: 'h2' | 'h3';
    showRank?: boolean;
};

const GeoRestaurantList: React.FC<GeoRestaurantListProps> = ({
    restaurants,
    headingLevel = 'h2',
    showRank = false,
}) => {
    const HeadingTag = headingLevel;

    return (
        <ol className="geo-restaurant-list">
            {restaurants.map((r, index) => (
                <li className="geo-restaurant-item" key={r.name}>
                    <HeadingTag>
                        {showRank ? `${index + 1}. ` : ''}
                        {r.name}
                    </HeadingTag>
                    <p className="geo-restaurant-cuisine">
                        {r.cuisine}
                        {r.neighborhood ? ` · ${r.neighborhood}` : ''}
                    </p>
                    <p>{r.description}</p>
                    {r.soltPath && (
                        <p>
                            <Link to={r.soltPath} className="geo-restaurant-link">
                                See dishes at {r.name} on Solt
                            </Link>
                        </p>
                    )}
                </li>
            ))}
        </ol>
    );
};

export default GeoRestaurantList;
